<!-- DESKTOP TOOLBAR -->
<mat-toolbar class="top-toolbar" [ngClass]="{ 'lightest-primary-background': account.accountStyles.inverse_toolbar, 'primary-background': !account.accountStyles.inverse_toolbar }" *ngIf="account">
  <!-- MOBILE MENU BUTTON -->
  <button
    mat-icon-button
    (click)="toggleSnav()"
    class="menu-icon-button d-md-none"
  >
    <mat-icon class="menu-icon">menu</mat-icon>
  </button>

  <span class="spacer"></span>

  <!-- LOGO -->
  <a routerLink="/">
    <img class="pv-logo" [src]="account.logoPhoto.thumbnail_url" height="50"
  /></a>


  <!-- LINKS (TOOLBAR-DTO) -->
  <div class="linkbar d-none d-md-flex" *ngIf="toolbarDTO">
    <!-- EACH TOP-LEVEL LINK -->
    <div class="link-wrapper" *ngFor="let route of toolbarDTO">
      <a *ngIf="route.link" [href]="route.link" class="link item hover-accent-background header-font route-link-nullify-color" target="_blank">{{ route.header }}</a>

      <!-- 4/15/24 demo shopify link here! -->
      <div *ngIf="route.route || route.toolbarColumns && route.toolbarColumns.length" class="link hover-accent-background" [routerLinkActive]="route.route ? 'lightest-primary-background' : ''"
          [routerLink]="route.route ? ((route.module && route.module.toLowerCase() != 'store') ? route.route : 'https://polyvinylrecords.com/')  : null">


        <!-- ROUTE NAME -->
        <div class="item header-font">
          {{ route.header  }}


          <!-- ARROW DROPDOWN -->
          <mat-icon *ngIf="((route.toolbarColumns && route.toolbarColumns.length) || (route.artists && route.artists.length)) && route.module.toLowerCase() != 'store'" class="menu-arrow">arrow_drop_down</mat-icon>
        </div>

        <!-- CHILD DROPDOWN -->
        <div class="subnav" *ngIf="route.toolbarColumns && route.toolbarColumns.length && !hide && route.module.toLowerCase() != 'store'">
          <div class="subnav-item hover-lightest-primary-background" *ngFor="let child of route.toolbarColumns[0]">
            <a *ngIf="child.route" [routerLink]="child.route" class="dark-color hover-primary-color" (click)="hideNav($event)">{{ child.label }}</a>
            <a *ngIf="!child.route && child.link" [href]="child.link" class="dark-color hover-primary-color" target="_blank" (click)="hideNav($event)">{{ child.label }}</a>
          </div>
        </div>

        <!-- STORE DROPDOWN -->
        <!-- <div class="subnav-container-store" *ngIf="route.module.toLowerCase() == 'store' && route.toolbarColumns && route.toolbarColumns.length && !hide">
           <div class="store-subnav row dark-color" (click)="noProp($event)">
            <div class="col-12 store-toolbar">
              <pv-store-toolbar></pv-store-toolbar>
            </div>

            <div class="col-2 store-column" *ngFor="let col of route.toolbarColumns">
              <div class="store-header dark-color">
                <a *ngIf="col[0].route" [routerLink]="col[0].route" class="primary-to-accent"><strong>{{ col[0].label }}</strong></a>
                <a *ngIf="!col[0].route && col[0].link" [href]="col[0].link" class="primary-to-accent" target="_blank"><strong>{{ col[0].label }}</strong></a>
                <strong *ngIf="!col[0].route && !col[0].link">{{ col[0].label }}</strong>
              </div>
              <div class="store-item" *ngFor="let child of col.slice(1)">
                <a *ngIf="child.route" [routerLink]="child.route" class="primary-to-accent" (click)="hideNav($event)">{{ child.label }}</a>
                <a *ngIf="!child.route && child.link" [href]="child.link" class="primary-to-accent" target="_blank" (click)="hideNav($event)">{{ child.label }}</a>
              </div>
            </div>
          </div>
        </div> -->

        <!-- ARTIST DROPDOWN -->
        <div
          class="subnav-container-artist"
          *ngIf="route.module.toLowerCase() == 'artist' && route.artists && route.artists.length && !hide"
        >
          <div class="store-subnav row">
            <div class="col-3 artist-col" *ngFor="let artist of myGetArtists(); let i = index">
              <a class="inner-artist-link dark-color hover-accent-color" [ngClass]="artist.class" [routerLink]="['/artist', artist.url_alias]" (click)="hideNav($event)">
                {{ artist.name }}
              </a>
            </div>

            <div class="col-3 artist-col">
              <a class="inner-artist-link dark-color hover-accent-color" [routerLink]="['/artist']" (click)="hideNav($event)">
                <strong>FULL ROSTER...</strong>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>



  <span class="spacer"></span>

  <!-- SHOPPING CART -->
  <span class="login" *ngIf="!loggedIn" routerLink="/login">Log In &nbsp; &nbsp;</span>
  <span *ngIf="loggedIn && !checkoutDTO.customer.is_wholesale && account.loyalty_feature" routerLink="/profile" class="account-anchor">
    <div class="account-container login">
      <div>Account</div>
      <pv-loyalty class="loyalty-container d-none d-lg-block" [toolbar]="true"></pv-loyalty>
    </div>
  </span>

  <span class="login" *ngIf="loggedIn && (checkoutDTO.customer.is_wholesale || !account.loyalty_feature)" routerLink="/profile">Account &nbsp; &nbsp;</span>

  <span class="cart-icon-button" [ngClass]="{ 'warn-color': checkoutDTO.cart.orderId }" routerLink="/cart" routerLinkActive="lightest-primary-background">
    <mat-icon
      class="menu-icon"
      [matBadgeHidden]="!getCartLength()"
      [matBadgeColor]="checkoutDTO.cart.orderId ? 'warn' : 'accent'"
      [matBadge]="getCartLength()"
      matBadgeOverlap="false"
    >
      {{ checkoutDTO.cart.orderId ? 'shopping_basket' : 'shopping_cart' }}
    </mat-icon>
  </span>

  <img class="d-none d-lg-block" *ngIf="!checkoutDTO.customer.is_wholesale && account.toolbarPhoto && account.toolbarPhoto.thumbnail_url && router.url != '/wholesale-login'" class="shipping-logo" [src]="account.toolbarPhoto.thumbnail_url" height="50">
  <span class="spacer d-none d-md-flex"></span>
</mat-toolbar>
<pv-alert-toolbar></pv-alert-toolbar>